<template>
  <div class="container">
    <!--banner-->
    <div class="nban pc">
      <img src="@/view/images/y49.jpg" />
    </div>
    <!-- <div class="mbx mbx_n pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">关于</a></p>
      </div>
    </div> -->
    <!--印刷管理培训内页-->
    <div class="pxn">
      <div class="commen">
        <div class="pxna">
          <div class="pxnaa">
            <h6>{{ datalist.courseName }}</h6>
            <div class="pxnaa_a fr">
              <a href="javascript:void(0);" @click="payment(1)">立即报名</a>
            </div>
            <div class="pxnaa_b fr">
              <a href="javascript:void(0);">课程咨询</a>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="pxnab">
            <!--<div class="bshare-custom fl">-->
            <!--<div class="bsPromo bsPromo2"></div>-->
            <!--<a id="aa" class="bshare-more bshare-more-icon more-style-addthis">课程分享</a>-->
            <!--</div>-->
            <div class="pxnab_a fl kcfx">
              <img src="@/view/images/y67.png" style="cursor: pointer;" />
              <p>课程分享</p>
              <div class="clearfix"></div>
              <vshare class="pxnab_aicon" :vshareConfig="vshareConfig"></vshare>
              <div class="clearfix"></div>
            </div>
            <div class="pxnab_a fl">
              <img src="@/view/images/y68.png" />
              <p>支持开发票</p>
              <div class="clearfix"></div>
            </div>
            <div class="pxnab_a fl">
              <img src="@/view/images/y69.png" />
              <p>{{ keshi }}节课时</p>
              <div class="clearfix"></div>
            </div>
            <div class="pxnab_a fl">
              <img src="@/view/images/y70.png" />
              <p>终身有效</p>
              <div class="clearfix"></div>
            </div>
            <div class="pxnab_c fr">
              <p>
                课程价格<span>¥{{ datalist.coursePrice }}</span>
              </p>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="pxnb">
          <div class="pxnba">
            <p :class="pxnbc == 1 ? 'on' : ''" @click="pxnbcbtn(1)">课程介绍</p>
            <p :class="pxnbc == 2 ? 'on' : ''" @click="pxnbcbtn(2)">章节目录</p>
            <div class="clearfix"></div>
          </div>
          <div class="pxnbb">
            <div class="pxnbc" v-if="pxnbc == 1">
              {{ datalist.courseDescription }}
              <!--<h6>印前色彩管理培训</h6>-->
              <!--<p>-->
              <!--本课程是印刷专业的专业基础课，主要讨论各种颜色的空间的转换，设备的色彩管理，颜色的描述与表达。本课程的前课程是《印刷色彩学》，后课程是印前与印刷工艺课程。通过本课程的学习，使学生能运用色彩转换技术，管理各种设备。</p>-->
              <!--<h6>课程教学基本要求</h6>-->
              <!--<p>全面系统的掌握色彩的描述与表达方法，掌握各种色彩转换技术；掌握各种设备的特征与特点，以便能有效地解决生产实践中发生的问题。</p>-->
              <!--<h6>教学的重点与难点</h6>-->
              <!--<p>教学的重点是色彩的表达与转换技术，教学的难点是各种设备之间的转换。</p>-->
              <!--<h6>本课程的特色</h6>-->
              <!--<p>本课程是印刷专业的一门基础课，主要采用课堂讲授教学法，辅之以必要实践，使学生通过本课程的学习，能容易理解专业课程的有关操作。</p>-->
              <!--<h6>教学的主要内容及其要求</h6>-->
              <!--<p>第一章 色彩的形成与色觉<br>教学内容：色觉的形成，物体色的形成，颜色感觉标准的观察条件。<br>教学要求：掌握色觉的形成，物体色的形成原理。</p>-->
            </div>
            <div class="pxnbc" v-else>
              <h6>{{ datalist.courseName }}</h6>
              <span>{{ zhangjie }}个章节/{{ keshi }}个课时</span>
              <div class="pxnbd_a" v-for="(item, index) in datalist.chapters">
                <h5>{{ item.chapterName }}</h5>
                <p v-for="(a, b) in item.sections" @click="childid(a.id)">
                  {{ a.sectionName }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="fhlb">
          <a href="javascript:volid(0);" @click="back()">返回课程列表</a>
        </div>
      </div>
      <div class="fa1f pxnx">
        <div class="commen">
          <div class="bt reveal-buytop">
            <h6>相关课程推荐</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa1fa pc reveal-buytop buyshow">
            <el-carousel
              class="cardShowban"
              height="400px"
              :loop="true"
              indicator-position="outside"
              :interval="3000"
              arrow="never"
            >
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <div class="fa1fa mob reveal-buytop">
            <div class="swiper-container" id="swiper_fa3">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--留言-->
    <!-- <div class="lyan reveal-buytop" style="margin-top: 0;">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>

<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'buyCourses',
  components: {
    CounSel,
  },
  data() {
    return {
      pxnbc: 1,
      id: '',
      datalist: '',
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
      zhangjie: 0,
      keshi: 0,
      vshareConfig: {
        shareList: [
          // 此处放分享列表（ID）
          'more',
        ],
        common: {
          // 此处放置通用设置
        },
        share: [
          {
            // 此处放置分享按钮设置
          },
        ],
        slide: [
          // 此处放置浮窗分享设置
        ],
        image: [
          // 此处放置图片分享设置
        ],
        selectShare: [
          // 此处放置划词分享设置
        ],
      },
    };
  },
  methods: {
    init() {
      const _this = this;
      _this.id = _this.$route.query.id;
      _this.courseslist();
    },
    back() {
      this.$router.go(-1); // 返回上一层
    },
    pxnbcbtn(id) {
      const _this = this;
      _this.pxnbc = id;
    },
    payment(id) {
      this.$router.push({ path: `/payment?id=${id}` });
    },
    courseslist() {
      const _this = this;
      const { id } = _this;
      const url = `${process.env.API_HOST}/portal/course/detail?id=${id}`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({
        // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'get',
        url,
        data: {},
      }).then((res) => {
        const json = res.data;
        if (json.code === 200) {
          const { data } = json.message;
          _this.datalist = data;
          _this.zhangjie = data.chapters.length;
          let keshis = 0;
          for (let i = 0; i < data.chapters.length; i++) {
            for (let a = 0; a < data.chapters[i].sections.length; a++) {
              keshis++;
            }
          }
          _this.keshi = keshis;
        }
      });
    },
  },
  mounted() {
    const Swiper2 = new Swiper('#swiper_fa3', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.kcfx {
  position: relative;
}
.pxnab_aicon {
  width: 100%;
  height: 23px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  opacity: 0;
}
.fa1fb {
  display: block !important;
}
</style>
<style>
.buyshow .el-carousel__indicators--horizontal {
  width: 100% !important;
  position: absolute !important;
  bottom: 0% !important;
  left: 0 !important;
  transform: translateX(0) !important;
  z-index: 99 !important;
  text-align: center;
}

.buyshow .el-carousel__button {
  cursor: pointer;
  width: 7px;
  height: 7px;
  margin: 0 2.5px;
  float: left;
  position: relative;
  transition: all ease 0 0.35s;
  background-color: #1f232a;
  border-radius: 50%;
  opacity: 1;
  transition: all ease 0.35s;
}

.buyshow .el-carousel__indicator.is-active button {
  background-color: #f6b415;
  width: 30px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/buycourses.vue